import { combineReducers } from 'redux';
import ArrayUtil from '@leverege/array-util'

import Constants from '~/actions/Constants'

const initialState = {
  shared : [],
  project : [],
  index : { }
};

function networks( state = initialState, action ) {

  switch ( action.type ) {

    case Constants.GET_SHARED_NETWORKS: {
      // TODO : MERGE IF STARTINDEX > 0
      const nIndex = Object.assign( state.index )
      const nProject = [].concat( state.project )
      const nShared = []
      const nState = { shared : nShared, index : nIndex, project : nProject }

      action.networks.items.forEach( ( net ) => {
        nIndex[net.id] = net
        nShared.push( net )
        ArrayUtil.replace( nProject, 'id', net.id, net )
      } )

      return nState
    }

    case Constants.GET_NETWORKS: {
      const nIndex = Object.assign( state.index )
      const nProject = []
      const nShared = [].concat( state.shared )
      const nState = { shared : nShared, index : nIndex, project : nProject }

      action.networks.items.forEach( ( net ) => {
        nIndex[net.id] = net
        nProject.push( net )
        ArrayUtil.replace( nShared, 'id', net.id, net )
      } )

      return nState
    }

    case Constants.ADD_NETWORK: {

      const nState = copy( state )
      nState.index[action.network.id] = action.network
      nState.project.push( action.network )
      
      return nState
    }

    case Constants.UPDATE_NETWORK: {

      const nState = copy( state )
      nState.index[action.network.id] = action.network
      if ( action.network.projectId != 'shared' ) {
        const c = ArrayUtil.find( nState.project, 'id', action.network.id )
        if ( c && c.projectId != action.network.projectId ) {
          ArrayUtil.remove( nState.project, 'id', action.network.id )
        } else {
          ArrayUtil.replace( nState.project, 'id', action.network.id, action.network )
        }
      }
      ArrayUtil.replace( nState.shared, 'id', action.network.id, action.network )
      return nState
    }

    case Constants.REMOVE_NETWORK: {
      
      const nState = copy( state )
      delete nState.index[action.network.id]
      ArrayUtil.remove( nState.project, 'id', action.network.id )
      ArrayUtil.remove( nState.shared, 'id', action.network.id )

      return nState
    }

    default:
      return state

  }
}

function copy( state ) {
  const nIndex = Object.assign( state.index )
  const nProject = [].concat( state.project )
  const nShared = [].concat( state.shared )
  return { shared : nShared, index : nIndex, project : nProject }
}

module.exports = networks;
